var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42446 1.37593C6.19014 1.14162 5.81025 1.14162 5.57593 1.37593L1.37593 5.57593C1.14162 5.81025 1.14162 6.19014 1.37593 6.42446C1.61025 6.65877 1.99014 6.65877 2.22446 6.42446L2.4002 6.24872V10.2002C2.4002 10.5316 2.66882 10.8002 3.0002 10.8002H4.2002C4.53157 10.8002 4.8002 10.5316 4.8002 10.2002V9.0002C4.8002 8.66882 5.06882 8.4002 5.4002 8.4002H6.60019C6.93157 8.4002 7.20019 8.66882 7.20019 9.0002V10.2002C7.20019 10.5316 7.46882 10.8002 7.80019 10.8002H9.0002C9.33157 10.8002 9.60019 10.5316 9.60019 10.2002V6.24872L9.77593 6.42446C10.0102 6.65877 10.3901 6.65877 10.6245 6.42446C10.8588 6.19014 10.8588 5.81025 10.6245 5.57593L6.42446 1.37593Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.95c8e0362efa4128aba53ef5db6890ed.svg";
export { ForwardRef as ReactComponent };